<template>
  <div class="px-4 pt-4 pb-0">
    <slot />
  </div>
</template>
